<template>
  <div>
    <div ref="multipleMap" class="map" :style="`height: ${height}px`"></div>
    <div id="toolbarDiv" class="esri-component esri-widget">
      <!-- <button
        id="distance"
        class="action-button esri-widget--button esri-interactive esri-icon-measure-line"
        style="margin-bottom: 10px"
        :title="$t('common_words.distance_measurement_tool')"
      ></button>
      <button
        id="area"
        class="action-button esri-widget--button esri-interactive esri-icon-measure-area"
        style="margin-bottom: 10px"
        :title="$t('common_words.area_measurement_tool')"
      ></button>
      <button
        id="clear"
        class="action-button esri-widget--button esri-interactive esri-icon-trash"
        style="margin-bottom: 10px"
        :title="$t('common_words.clear_measurement')"
      ></button> -->
    </div>
  </div>
</template>
<script>
export default {
  name: 'multiple-map',
  props: {
    height: {
      type: Number,
      default: 400,
    },
  },
};
</script>
